/* eslint-env browser */
const { captureException } = require('./sentry-service')

if (!process.env.BROWSER && !global.window) {
  global.window = {}
}

window.subscribers = window.subscribers || {}

const pubsub = {}

let lastId = 0

pubsub.subscribe = pubsub.sub = (event, handler) => {
  if (!window.subscribers[event]) {
    window.subscribers[event] = []
  }
  lastId += 1
  window.subscribers[event].push({ id: lastId, handler })
  return lastId
}

pubsub.publish = pubsub.pub = (event, args) => {
  const eventSubscribers = window.subscribers[event]

  if (!eventSubscribers) {
    return
  }
  eventSubscribers.forEach(subscriber => {
    if (subscriber && typeof subscriber.handler === 'function') {
      try {
        subscriber.handler({ event, args })
      } catch (e) {
        captureException(e)
        console.error('Something went wrong', e)
      }
    }
  })
}

pubsub.unsubscribe = pubsub.unsub = (event, id) => {
  window.subscribers[event] = (window.subscribers[event] || []).filter(subscriber => subscriber.id !== id)
}

module.exports = pubsub
